import { NgModule } from 'ng-metadata/core';
import {TagsResultsService} from './tagsResults.service';
import {PrmTagsResults} from './tagsResults.directive';

@NgModule({
    declarations: [
        PrmTagsResults
    ],
    providers: [
        TagsResultsService
    ],
    imports:[

    ]
})
export class TagsResultsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsResults/tagsResults.module.ts